
import { Component, Vue, Prop } from 'vue-property-decorator';
import authService from '@/services/auth-services';
import depositService from '@/services/deposit-services';
import { DepositModel } from '@/models/deposit'
import { APP_CONFIG } from '@/config/app-config';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';
import Loading from 'vue-loading-overlay';
import formatNumber from '@/shared/filters/format-number';

@Component({
    components: {
        ConfirmModal,
        Loading
    }
})
export default class DepositDetailFooter extends Vue {
    @Prop({default: null})
    private deposit!: DepositModel;
    private customerInfo: any;
    private isConfirm = false;
    private showNextConfirm = true;
    private isLoading = false;
    private modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';
    private actionSelected = '';
    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }
    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }
    private async cancelOrder() {
        const dataRequest =  {
            Status: 1
        };
        const result = await depositService.updateDeposit(this.deposit.id, dataRequest);
        
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Hủy đơn hàng thành công!',
            });
            this.$emit('eventCancelOrder', { status: 1 });
        }
    }

    private async payOrder() {
        this.actionSelected = 'payment';
        this.modalContent = `<div style="color: #111">Số tiền bạn cần thanh toán là <label class="fb text-danger">${ formatNumber(this.deposit.totalPriceVND - this.deposit.payment, '0,0') } vnđ.</label>
                                    <div>Bạn có muốn thanh toán không?</div></div>`;
        this.isConfirm = true;
        this.showNextConfirm = true;
    }

    private async onPaymentOrder() {
        await this.getCustomersInfo();
        if (this.customerInfo.Wallet >= (this.deposit.totalPriceVND - this.deposit.payment)) {
            this.isLoading = true;

            const dataRequest = {
                Status: 9,
                PaymentStatus: 1,
                IsUpdateFeeShip: 1,
                Deliverable: 1,
                Payment: this.deposit.totalPriceVND - this.deposit.payment
            };
            const result = await depositService.updateDeposit(this.deposit.id, dataRequest);
            if (result && result.status === 200 && result.data.status === 200) {
                // if(this.deposit.status !== 9) {
                //     (window['getApp'] as any).$emit('SET_SELECTED_ORDER', [this.deposit].map(x => {
                //         return {
                //             id: x.id,
                //             orderType: 2,
                //             orderWeight: x.orderWeight,
                //             totalAmountVND: x.totalPriceVND,
                //             deposit: x.payment,
                //             isChecked: true
                //         }
                //     }));
                //     this.actionSelected = 'request';
                //     this.modalContent = `<div style="color: #111; font-size: 16px; font-weight: 700;">Thanh toán đơn hàng thành công.</div>
                //     <div style="color: #d9534f; font-size: 16px; font-weight: 700;">Hãy tạo yêu cầu giao để ngay để kho gửi hàng cho bạn sớm nhất!</div>`;
                //     this.isConfirm = true;
                //     this.showNextConfirm = true;
                // } else {
                //     Vue.notify({group: 'foo',type: 'success',title: 'Thông báo!',text: 'Thanh toán đơn hàng thành công!'});
                // }
                Vue.notify({group: 'foo',type: 'success',title: 'Thông báo!',text: 'Thanh toán đơn hàng thành công!'});
                this.$emit('eventPaymentOrder', { status: 9 });
                this.isLoading = false;
                this.getCustomersInfo();
            }
        } else {
            this.modalContent = '<div style="color: #111;">Số tiền trong ví của bạn không đủ để thanh toán.</div><div class="text-danger">Hãy nạp tiền để tiếp tục thanh toán!</div>';
            this.isConfirm = true;
            this.showNextConfirm = false;
        }
    }

    private async getCustomersInfo() {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                this.customerInfo = result.data.data || {};
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
            }
        }
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
    }

    private onAcceptModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
        if (eventData.data === 'OK' && this.actionSelected === 'payment') {
            this.onPaymentOrder();
        } else if (eventData.data === 'OK' && this.actionSelected === 'request') {
            this.$router.push({ name: 'yeu-cau-giao-hang2' });
        }
    }

    private async created() {
        await this.getCustomersInfo();
    }
}
